// Purpose: This function is used to clean the initial state from the query string.
// Copied from the Mono Repo Common-Library in Ascend
import { Preferences } from "./useSearchBarParams";

export default function cleanInitialStateFromQuery<T extends object>(
  searchParams: T,
  preferences: Preferences<T>
): T {
  const defaultFormatDashToSlash: (keyof T)[] = [
    "startDate" as keyof T,
    "endDate" as keyof T,
    "fromDate" as keyof T,
    "toDate" as keyof T,
  ];
  const params = { ...searchParams };
  [...defaultFormatDashToSlash, ...(preferences.replaceSlashes || [])].forEach(
    item => {
      const value = params[item];
      if (value && typeof value === "string") {
        (params as any)[item] = value.replace(/-/g, "/");
      }
    }
  );
  // convert param strings with multiple values to an array
  Object.entries(params).forEach(([key, value]) => {
    if (value.includes(",")) (params as any)[key] = value.split(",");
  });
  return params;
}
